import LandWrapper from '@/features/lands/components/LandWrapper';

export default function LandPage() {
  return (
    <div className="flex">
      <LandWrapper />
    </div>
  );
}
